"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _LearningBase2 = _interopRequireDefault(require("./LearningBase"));
var _Utils = _interopRequireDefault(require("./Utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var classes = exports.classes = ['ai_learning_train', 'ai_learning_logistic_regression', 'logistic_regression_attr_1', 'logistic_regression_attr_2', 'logistic_regression_attr_3', 'logistic_regression_attr_4', 'logistic_regression_attr_5', 'logistic_regression_attr_6'];
var LogisticRegression = /*#__PURE__*/function (_LearningBase) {
  function LogisticRegression() {
    var _this;
    (0, _classCallCheck2["default"])(this, LogisticRegression);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LogisticRegression, [].concat(args));
    (0, _defineProperty2["default"])(_this, "type", 'logistic_regression');
    return _this;
  }
  (0, _inherits2["default"])(LogisticRegression, _LearningBase);
  return (0, _createClass2["default"])(LogisticRegression, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2,
        _table$select3;
      var name = _ref.name,
        url = _ref.url,
        result = _ref.result,
        table = _ref.table,
        trainParam = _ref.trainParam;
      this.name = name;
      this.trainParam = trainParam;
      this.result = result;
      this.table = table;
      this.trainCallback = function (value) {
        _this2.view.setValue(value);
      };
      this.trained = true;
      this.attrLength = (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0;
      if (this.attrLength === 1) {
        this.chartEnable = true;
      }
      if (this.url !== url) {
        this.load(url);
        this.url = url;
      }
      this.fields = table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      this.predictFields = table === null || table === void 0 || (_table$select3 = table.select) === null || _table$select3 === void 0 || (_table$select3 = _table$select3[1]) === null || _table$select3 === void 0 ? void 0 : _table$select3.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      if (!_Utils["default"].isWebGlSupport()) {
        tf.setBackend('cpu');
      }
    }
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
        var model, modelData;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return tf.loadLayersModel(url);
            case 1:
              model = _context.sent;
              modelData = new Promise(function (resolve) {
                return model.save({
                  save: function save(data) {
                    var _data$modelTopology;
                    var layers = data === null || data === void 0 || (_data$modelTopology = data.modelTopology) === null || _data$modelTopology === void 0 || (_data$modelTopology = _data$modelTopology.config) === null || _data$modelTopology === void 0 ? void 0 : _data$modelTopology.layers;
                    if (Array.isArray(layers)) {
                      data.modelTopology.config.layers.forEach(function (layer) {
                        var _layer$config;
                        if (layer !== null && layer !== void 0 && (_layer$config = layer.config) !== null && _layer$config !== void 0 && _layer$config.name) {
                          layer.config.name = "".concat(layer.config.name, "_ws");
                        }
                      });
                    }
                    if (Array.isArray(data.weightSpecs)) {
                      data.weightSpecs.forEach(function (spec) {
                        var splits = spec.name.split('/');
                        splits[0] = "".concat(splits[0], "_ws");
                        spec.name = splits.join('/');
                      });
                    }
                    resolve(data);
                  }
                });
              });
              _context.next = 2;
              return tf.loadLayersModel({
                load: function load() {
                  return modelData;
                }
              });
            case 2:
              this.model = _context.sent;
              model.dispose();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load(_x) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "reload",
    value: function () {
      var _reload = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return tf.loadLayersModel(url || this.url);
            case 1:
              this.model = _context2.sent;
              this.isLoaded = true;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reload(_x2) {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }, {
    key: "train",
    value: function () {
      var _train = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this3 = this;
        var currentEpoch, percent, _this$trainParam, _this$trainParam$vali, validationRate, _this$trainParam$test, testRate, _getData, trainData, validateData, testArr, select, fields, valueMap, dataLength, numClass, _yield$this$evaluate, score, confusionMatrix, accuracy, f1, precision, recall;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.setTable();
              this.trained = false;
              currentEpoch = 0;
              percent = 0;
              this.trainCallback(1);
              _this$trainParam = this.trainParam, _this$trainParam$vali = _this$trainParam.validationRate, validationRate = _this$trainParam$vali === void 0 ? 0.25 : _this$trainParam$vali, _this$trainParam$test = _this$trainParam.testRate, testRate = _this$trainParam$test === void 0 ? 0.2 : _this$trainParam$test;
              _getData = getData(validationRate, testRate, this.table, this.trainParam), trainData = _getData.trainData, validateData = _getData.validateData, testArr = _getData.testArr, select = _getData.select, fields = _getData.fields, valueMap = _getData.valueMap, dataLength = _getData.dataLength, numClass = _getData.numClass;
              this.valueMap = Object.fromEntries(Object.entries(valueMap).map(function (_ref2) {
                var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];
                return [value, key];
              }));
              this.model = createModel(dataLength, numClass);
              _context3.next = 1;
              return trainModel(this.model, trainData, validateData, this.trainParam, function () {
                currentEpoch = currentEpoch + 1;
                percent = (0, _floor2["default"])(currentEpoch / _this3.trainParam.epochs * 100);
                _this3.trainCallback(Math.min(percent, 100));
              });
            case 1:
              this.lastHistory = _context3.sent;
              _context3.next = 2;
              return this.evaluate(this.model, testArr, valueMap, numClass);
            case 2:
              _yield$this$evaluate = _context3.sent;
              score = _yield$this$evaluate.score;
              confusionMatrix = _yield$this$evaluate.confusionMatrix;
              accuracy = score.accuracy, f1 = score.f1, precision = score.precision, recall = score.recall;
              this.trained = true;
              this.result = {
                select: select,
                fields: fields,
                confusionMatrix: confusionMatrix,
                accuracy: accuracy,
                f1: f1,
                valueMap: this.valueMap,
                precision: precision,
                recall: recall
              };
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function train() {
        return _train.apply(this, arguments);
      }
      return train;
    }()
  }, {
    key: "predict",
    value: function () {
      var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(array) {
        var _this$result;
        var xs, preds, resultArray, valueMap;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.model) {
                _context4.next = 1;
                break;
              }
              throw new Error("can't predict: no model");
            case 1:
              xs = tf.tensor([array]);
              preds = this.model.predict(xs);
              resultArray = preds.arraySync();
              valueMap = ((_this$result = this.result) === null || _this$result === void 0 ? void 0 : _this$result.valueMap) || {};
              this.predictResult = resultArray.map(function (arr) {
                return arr.map(function (probability, index) {
                  return {
                    probability: (0, _floor2["default"])(probability, 3),
                    className: valueMap[index + 1]
                  };
                });
              }).flat();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function predict(_x3) {
        return _predict.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "evaluate",
    value: function () {
      var _evaluate = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(model) {
        var validateData,
          classMap,
          numClass,
          evalData,
          xs,
          ys,
          preds,
          pred,
          confusionMatrixZip,
          matrixArray,
          confusionMatrix,
          score,
          _args5 = arguments;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              validateData = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [{
                x: 0,
                y: 0
              }];
              classMap = _args5.length > 2 ? _args5[2] : undefined;
              numClass = _args5.length > 3 ? _args5[3] : undefined;
              evalData = validateData;
              xs = tf.tensor(Array.from(evalData, function (evalData) {
                return evalData.x;
              }));
              ys = tf.tensor(Array.from(evalData, function (evalData) {
                return evalData.y;
              })).argMax(-1);
              preds = model.predict(xs);
              pred = preds.argMax(-1);
              _context5.next = 1;
              return tf.math.confusionMatrix(ys, pred, numClass);
            case 1:
              confusionMatrixZip = _context5.sent;
              matrixArray = Array.from(confusionMatrixZip.dataSync());
              confusionMatrix = _Utils["default"].arrayToMatrix(matrixArray, numClass);
              score = _Utils["default"].getScores(confusionMatrix, numClass);
              return _context5.abrupt("return", {
                score: score,
                confusionMatrix: confusionMatrix
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function evaluate(_x4) {
        return _evaluate.apply(this, arguments);
      }
      return evaluate;
    }()
  }]);
}(_LearningBase2["default"]);
var _default = exports["default"] = LogisticRegression;
function createModel(inputShape) {
  var numClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var model = tf.sequential({
    layers: [tf.layers.dense({
      name: 'log_dense_ws',
      inputShape: [inputShape],
      units: numClasses,
      activation: numClasses === 2 ? 'sigmoid' : 'softmax',
      useBias: false,
      kernelInitializer: tf.initializers.varianceScaling({})
    })]
  });
  return model;
}
function trainModel(_x5, _x6, _x7, _x8, _x9) {
  return _trainModel.apply(this, arguments);
}
function _trainModel() {
  _trainModel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(model, inputs, outputs, trainParam, onEpochEnd) {
    var _trainParam$batchSize, batchSize, _trainParam$epochs, epochs, _trainParam$optimizer, optimizerStr, _trainParam$learningR, learningRate, optimizer;
    return _regenerator["default"].wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _trainParam$batchSize = trainParam.batchSize, batchSize = _trainParam$batchSize === void 0 ? 0 : _trainParam$batchSize, _trainParam$epochs = trainParam.epochs, epochs = _trainParam$epochs === void 0 ? 0 : _trainParam$epochs, _trainParam$optimizer = trainParam.optimizer, optimizerStr = _trainParam$optimizer === void 0 ? 'adm' : _trainParam$optimizer, _trainParam$learningR = trainParam.learningRate, learningRate = _trainParam$learningR === void 0 ? 0.1 : _trainParam$learningR;
          optimizer = optimizerStr === 'adm' ? tf.train.adam(learningRate * 1) : tf.train.sgd(learningRate * 1);
          model.compile({
            optimizer: optimizer,
            loss: tf.losses.meanSquaredError,
            metrics: ['acc', 'ce']
          });
          _context6.next = 1;
          return model.fitDataset(inputs.batch(batchSize * 1), {
            epochs: epochs * 1,
            validationData: outputs.batch(batchSize * 1),
            callbacks: {
              onEpochEnd: onEpochEnd
            }
          });
        case 1:
          return _context6.abrupt("return", _context6.sent);
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _trainModel.apply(this, arguments);
}
function getData(validationRate, testRate, data, trainParam) {
  var tempMap = {};
  var tempMapCount = {};
  var _data$select = data.select,
    select = _data$select === void 0 ? [[0], [1]] : _data$select,
    table = data.data,
    fields = data.fields;
  var _select = (0, _slicedToArray2["default"])(select, 2),
    attr = _select[0],
    predict = _select[1];
  var filtered = table.filter(function (row) {
    return !select[0].some(function (selected) {
      return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
    });
  });
  var dataArray = filtered.map(function (row) {
    return {
      x: attr.map(function (i) {
        return parseFloat(row[i]) || 0;
      }),
      y: _Utils["default"].stringToNumber(predict[0], row[predict[0]], tempMap, tempMapCount)
    };
  }).map(function (row) {
    var yRow = Array(tempMapCount[predict[0]]).fill(0);
    yRow[row.y - 1] = 1;
    return {
      x: row.x,
      y: yRow
    };
  });
  var _sliceArray = sliceArray(dataArray, validationRate, testRate),
    _sliceArray2 = (0, _slicedToArray2["default"])(_sliceArray, 3),
    train = _sliceArray2[0],
    validate = _sliceArray2[1],
    test = _sliceArray2[2];
  return {
    trainData: arrayToZip(train),
    validateData: arrayToZip(validate),
    testArr: test,
    select: select,
    fields: fields,
    valueMap: _objectSpread({}, tempMap[predict[0]]),
    dataLength: attr.length,
    numClass: tempMapCount[predict[0]]
  };
}
function sliceArray(dataArray) {
  var validationRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.25;
  var testRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.2;
  _Utils["default"].shuffle(dataArray);
  var testNum = dataArray.length - Math.floor(dataArray.length * testRate);
  var validateNum = Math.floor(testNum * validationRate);
  var validateArr = dataArray.slice(0, validateNum);
  var trainArr = dataArray.slice(validateNum, testNum);
  var testArr = dataArray.slice(testNum, dataArray.length);
  return [trainArr, validateArr, testArr];
}
function arrayToZip(array) {
  var xs = tf.data.array(array.map(function (v) {
    return v.x;
  }));
  var ys = tf.data.array(array.map(function (v) {
    return v.y;
  }));
  return tf.data.zip({
    xs: xs,
    ys: ys
  });
}